import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CityHero from '../../components/feature/CityHero';
import Services from '../home/components/Services';
import Testimonials from '../home/components/Testimonials';
import Contact from '../home/components/Contact';
import FAQ from '../home/components/FAQ';

export default function ReparationFenetreCorbas() {
  return (
    <>
      <div className="min-h-screen bg-white">
        <Navbar />
        <CityHero 
          cityName="Corbas"
          imageSeq="corbas-hero-004"
        />
        <Services />
        <Testimonials />
        <Contact />
        <FAQ />
        <Footer />
      </div>
    </>
  );
}
